<template>
  <Button label="Clear" class="ms-2 p-button-secondary small-button" @click="$emit('clearbtn')" />
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
// import "bootstrap/dist/css/bootstrap.css";
export default defineComponent({
  setup() {
    return {};
  },
});
</script>

<style>
.small-button {
  padding: 7px 10px !important;
}
</style>